/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const modalDetailTokens = {
  ContainerBorderRadius: '16px',
  ContainerSpacingVertical: '20px',
  ContainerSpacingHorizontal: '20px',
  ContentBackgroundColorBaseDefault: '#ffffff',
  SidebarBackgroundColorBaseDefault: '#1c2222',
  SidebarFontColorBaseDefault: '#c4c4c4',
  CloseActionBackgroundColorBaseDefault: 'transparent',
  CloseActionGraphicColorBaseDefault: '#232b2b',
  CloseActionGraphicColorBaseHover: '#ffffff',
  CloseActionGraphicSizeBaseDefault: '1.6rem',
  ItemFontColorBaseDefault: 'inherit',
  ItemFontColorBaseHover: '#ffffff',
  ItemFontColorActiveDefault: '#ffffff',
  ItemFontSizeBaseDefault: '14px',
  ItemFontLeadingBaseDefault: '20px',
  ItemFontWeightBaseDefault: '400',
  ItemBackgroundColorBaseDefault: '#232b2b',
  ItemSpacingVerticalDesktop: '8px',
  ItemSpacingVerticalMobile: '12px',
  ActionFontSizeBaseDefault: '14px',
  ActionFontWeightBaseDefault: '500',
} as const;
